require('./axios');
require('./vuelidate');
require('./vue-progressbar');
require('./vue-toasted');
require('./geolocation');
require('./moment');
require('./select');
